<template>
  <div class="page-container order-interception">
    <div class="main">
      <page :url="url" :form="form" @reset @select-data="handleSelectionChange">
        <template slot="pageHeader">
          <div class="order-summary">
            {{
              $t('message.selectedOrderSummary', {selected: multipleSelection.length, amount: totalAmount})
            }}
          </div>

        </template>

        <template slot="tableSearch">
          <el-form-item v-if="ROLE_TYPE.isManager() || ROLE_TYPE.isAgent()"
                        :label="$t('text.merchant')">
            <el-select v-model="form.appId"
                       filterable
                       :placeholder="$t('message.chooseOne')"
                       popper-class="eloption">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="merchant in merchantList"
                         :label="merchant.value + '-' + merchant.name"
                         :key="merchant.value"
                         :value="merchant.value"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.merchantOrderId')">
            <el-input v-model="form.merchantOrderId"
                      style="width: 280px"
                      maxlength="50"/>
          </el-form-item>
          <el-form-item :label="$t('text.platformOrderId')">
            <el-input v-model="form.channelOrderId"
                      style="width: 280px"
                      maxlength="100"/>
          </el-form-item>
          <el-form-item v-if="ROLE_TYPE.isManager()"
                        :label="$t('text.paymentChannel')">
            <el-select v-model="form.channelId"
                       filterable
                       :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option v-for="item in payOption"
                         :key="item.value"
                         :label="item.name"
                         :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('text.orderStatus')">
            <el-select v-model="form.status"
                       :placeholder="$t('message.chooseOne')">
              <el-option :label="$t('option.all')"
                         value=""/>
              <el-option :label="$t('orderStatus.00')"
                         value="00"/>
              <el-option :label="$t('orderStatus.02')"
                         value="02"/>
            </el-select>
          </el-form-item>
        </template>


        <template slot="buttonArea">
          <el-button type="primary"
                     @click="exportDetail"
                     size="small">
            {{ $t('text.export') }}
          </el-button>
          <br/>
          <el-button type="danger"
                     :disabled="multipleSelection.length === 0"
                     @click="handleManualFailureClick(strMultipleSelection)"
                     size="small">
            {{ $t('text.manualFailure') }}
          </el-button>

          <el-button type="warning"
                     :disabled="multipleSelection.length === 0"
                     @click="handleResubmitClick()"
                     size="small"
                     style="margin-left: 75vw"
          >
            {{ $t('text.resubmit') }}
          </el-button>
        </template>

        <template slot="tableColumn">
          <el-table-column type="selection" width="50" align="center" :selectable="selectable"/>
          <el-table-column prop="merchantName"
                           width="180px"
                           :label="$t('text.merchant')"
                           align="center"/>
          <el-table-column prop="status"
                           width="130px"
                           :label="$t('text.orderStatus')"
                           align="center">
            <template slot-scope="scope">
              <el-tag size="medium"
                      :type="scope.row.status === '00'
                               ? 'warning'
                               : scope.row.status === '02'
                               ? 'danger'
                               : 'primary'">
                {{ $formatter.formatOrderStatus(null, null, scope.row.status, null) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="failedTimes"
                           width="130px"
                           :label="$t('text.failedTimes')"
                           align="center"/>

          <el-table-column prop="remark"
                           width="160px"
                           :label="$t('text.failedReason')"
                           align="center"/>

          <el-table-column prop="transactionTime"
                           width="160px"
                           :label="$t('text.transactionTime')"
                           align="center">
            <template slot-scope="scope">
              <div> {{
                  $formatter.formatDate(null, null, scope.row.originalCreateDate + scope.row.originalCreateTime, null)
                }}
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="ROLE_TYPE.isManager()"
                           prop="channelName"
                           width="140px"
                           :label="$t('text.paymentChannel')"
                           align="center"/>

          <el-table-column prop="merchantOrderId"
                           width="130px"
                           :label="$t('text.merchantOrderId')"
                           align="center">
          </el-table-column>

          <el-table-column prop="orderIdForShowing"
                           width="130px"
                           :label="$t('text.platformOrderId')"
                           align="center">
          </el-table-column>

          <el-table-column prop="orderAmount"
                           width="130px"
                           :label="$t('text.amount')"
                           align="center">
            <template slot-scope="scope">
              <div> {{ formatOrderAmount(scope.row.orderAmount) }}</div>
            </template>
          </el-table-column>

        </template>

      </page>

      <BatchOrderResubmit :show.sync="showResubmitDialog" :value="strMultipleSelection" :amount="totalAmount"
                          :action="action"/>

    </div>
  </div>
</template>
<script>
import {ROLE_TYPE} from "@/utils/Constant";
import Page from "@/components/Page.vue";
import BatchOrderResubmit from "@/views/order/BatchOrderResubmit.vue";
import row from "element-ui/packages/row";

export default {
  name: "Systems",
  computed: {
    row() {
      return row
    },
    ROLE_TYPE() {
      return ROLE_TYPE;
    },
    totalAmount() {
      let selectedTotalAmount = 0;
      for (const item of this.multipleSelection) {
        selectedTotalAmount += item.orderAmount;
      }
      return selectedTotalAmount;
    }
  },
  components: {
    page: Page,
    BatchOrderResubmit: BatchOrderResubmit


  },
  data() {
    return {
      url: "/orderInterception/selectList",
      multipleSelection: [],
      strMultipleSelection: [],
      action: "",
      payOption: [],
      failedTimes: "",
      orderAmount: "",
      form: {
        appId: "",
        status: "",
        remark: "",
        merchantOrderId: "",
        orderIdForShowing: "",
      },
      showDialog: false,
      merchantList: [],
      showResubmitDialog: false,
      selectedCount: "",
      selectedTotalAmount: Number
    };
  },
  methods: {
    reset() {
    },
    selectable(row) {
      return row.status === '02';
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
      this.strMultipleSelection = this.multipleSelection.map(
          ({orderId}) => orderId
      );
    },
    exportDetail() {
      this.loading = true;
      this.axios
          .get("/orderInterception/export", {
            params: this.form,
            responseType: "blob"
          })
          .then((res) => {
            if (res.data) {
              // 回excel資料，瀏覽器下載
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", this.$t('text.orderInterception.xlsx'));
              document.body.appendChild(link);
              link.click();
            } else if (res.text) {
              // 回JSON，開彈窗
              res
                  .text()
                  .then(JSON.parse)
                  .then((res) => {
                    if (res.code !== 200) {
                      this.$message({
                        message: res.msg,
                        type: "error"
                      });
                    } else {
                      this.$message({
                        message: res.msg,
                        type: "success"
                      });
                    }
                  });
            }
          });
      this.loading = false;
    },
    handleResubmitClick() {
      this.action = "batchResubmitOrder"
      this.showResubmitDialog = true;
      this.selectedTotalAmount = this.totalAmount;
    },
    handleManualFailureClick(orderIds) {

      let refactorOrder = orderIds.join(',');

      let params = {
        orderIds: refactorOrder
      }
      const content =
          `${this.$t('message.selectedOrderSummary', {
            selected: this.multipleSelection.length,
            amount: this.totalAmount
          })}`;
      this.$confirm(
          content,
          this.$t('text.manualFailure'),
          {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }
      ).then(() => {
        this.axios.post("/orderInterception/failed", params)
            .then(res => {
              if (res.code === 200) {
                this.$bus.$emit('refresh') //通知刷新
                this.$notify({
                  title: '提示',
                  message: res.msg,
                  type: 'success'
                });
              } else {
                this.$notify.error({
                  title: '提示',
                  message: res.msg
                });
              }
            })
      }).catch(() => {

      });
    },

    formatOrderAmount(orderAmount) {
      if (typeof orderAmount === 'number') {
        return orderAmount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      return orderAmount;
    }
  },
  created() {
    this.reset();

    this.$axios
        .get("/merchant/selectListForOption", {params: {}})
        .then((res) => {
          this.merchantList = res.data;
        });

    this.$axios
        .get("/orderInterception/payout-channel-option", {params: {}})
        .then((res) => {
          res.data.map((item) => {
              this.payOption.push(item);

          });
        });
  }
}
</script>